import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const hasActiveVouchers = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.data?.ActivatedVouchers?.length > 0);
